export const HOME_PAGE = "home";
export const LOGIN_PAGE = "login";
export const REGISTER_PAGE = "register";
export const EXAMPLE_360_PAGE = "examples";
export const CONTACT_PAGE = "contact";
export const TESTS_PAGE = "tests";
export const SINGLE_TEST_PAGE = "test";
export const SIGNS_QUESTIONS_PAGE = "signs";
export const INFO_PAGE = "info";
export const APPLICATION_GUIDE_PAGE = "application-guide";
